// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__E6JQt","statusType":"styles_statusType__4d_Gk"};